import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ExpirationShips } from 'app/_models/expiration';
import { ExpirationService } from 'app/_services/expiration.service';
import { HttpErrorHandler } from 'app/shared/http-error-handler';
import { List } from 'app/shared/list';

interface Ship {
  id: number;
  name: string;
}

interface Expiration {
  id: number;
  expiration_date: string;
  ship: Ship;
  association: number;
}

interface ExpirationList {
  id: number;
  name: string;
  expiration: any;
  expiration_type: string;
  expiration_date: string;
  license_modality: string | null;
  person_name: string | null;
  radiobaliza_type: string | null;
  serial_number: string | null;
  ship: number;
  zafa_expiration_date: string | null;
}

@Component({
  selector: 'app-expirations',
  templateUrl: './expiration-list.component.html',
  styleUrls: ['./_expiration-list.component.scss'],
})
export class ExpirationListComponent extends List implements OnInit {
  expiration_types: any;

  ship_list: { num_expirations: number; id: number; name: string; reminders: any[] }[] = [];
  filtered_ships: { num_expirations: number; id: number; name: string }[] = [];
  selected_ship: any = null;
  debounceTimeout: any;

  expirations_list: ExpirationList[] = [];
  expirations_by_group: any;
  expirations_by_group_filtered: any;
  search_ship_value = '';
  search_expiration_value = '';
  expirations_child_data: any = [];
  show_button_disabled: any;
  dataServiceSubscription: any;

  load_expirations: Boolean = false;
  total_expirations: Expiration[] = [];
  load_ships = false;

  update_app_menu = false;
  expirations_types: any;
  delete_list: number[] = [];

  constructor(
    private expirationService: ExpirationService,
    private router: Router,
    private route: ActivatedRoute,
    protected httpErrorHandler: HttpErrorHandler
  ) {
    super(expirationService, new ExpirationShips(), router, route);
  }

  ngOnInit() {
    this.getExpirationsTypes();
    this.getExpirationsAssociation();
    this.show_button_disabled = true;
  }

  getChildData(data: any) {
    if (data.length <= 0) {
      return;
    }
    this.show_button_disabled = this.expirations_child_data.length !== 0;
    data.forEach((expiration: any) => {
      if (!this.expirations_child_data[expiration.expiration_type]) {
        this.expirations_child_data[expiration.expiration_type] = [];
        this.expirations_child_data[expiration.expiration_type].push(expiration);
      } else {
        const index = this.expirations_child_data[expiration.expiration_type].findIndex((expiration_item: any) => {
          return expiration_item.id === expiration.id;
        });

        if (index === -1) {
          this.expirations_child_data[expiration.expiration_type].push(expiration);
        }
      }
    });
  }

  saveData() {
    if (this.show_button_disabled) {
      return;
    }
    this.load_expirations = true;

    if (this.delete_list) {
      this.delete_list.forEach((id) => {
        this.expirationService.deleteExpiration(id).subscribe(() => {
          this.getExpirationsAssociation();
        });
      });
    }

    if (this.expirations_child_data) {
      const array: any[] = [];
      for (const key in this.expirations_child_data) {
        if (this.expirations_child_data.hasOwnProperty(key)) {
          const expiration_types = this.expirations_child_data[key];
          const newTypes = expiration_types.filter((expiration: any) => {
            if (!expiration.date && !expiration.text) {
              this.expirationService.deleteExpiration(expiration.id).subscribe(() => {
                this.getExpirationsAssociation();
              });
            }
            return expiration.date || expiration.text;
          });
          array.push(newTypes);
        }
      }

      const postData = {
        expirations: array,
      };

      this.expirationService.updateExpirations(postData).subscribe((data) => {
        this.expirations_child_data = [];
        this.getExpirationsAssociation();
      });
    }
    this.show_button_disabled = true;
  }

  undoChanges() {
    if (this.show_button_disabled) {
      return;
    }
    this.expirations_child_data = [];
    this.delete_list = [];
    this.getExpirationsAssociation();
    this.show_button_disabled = true;
  }

  deleteExpiration(info: any) {
    this.show_button_disabled = false;
    this.delete_list.push(info);
  }

  getExpirationsTypes() {
    this.expirationService.getExpirationsTypes().subscribe((data) => (this.expiration_types = data));
  }

  getExpirationsAssociation() {
    this.update_app_menu = true;
    this.expirationService.getExpirationsAssociaion().subscribe((data) => {
      this.ship_list = data;
      this.filtered_ships = this.ship_list;
      this.selected_ship = this.selected_ship === null ? this.ship_list[0] : this.selected_ship;
      this.getExpirations(this.selected_ship.id);
      this.update_app_menu = false;
      this.load_ships = true;
    });
  }

  shipChange(ship: Ship) {
    if (this.selected_ship.id === ship.id) {
      return;
    }
    if (this.selected_ship === null) {
      return;
    }
    this.selected_ship = ship;
    this.expirations_child_data = [];
    this.show_button_disabled = true;
    this.getExpirations(this.selected_ship.id);
  }

  getExpirations(ShipId: number) {
    this.load_expirations = true;
    this.expirationService.getExpirationsShip(ShipId).subscribe((data) => {
      this.expirations_list = [];
      this.expirations_list = data;

      const newExpirations = this.expiration_types.map((expirations: any, index: number) => {
        const expirations_type = this.expirations_list.filter((expiration) => expiration.expiration.name === expirations.name);
        return {
          ...expirations,
          expirations: expirations_type,
        };
      });
      this.load_expirations = false;
      this.expirations_by_group = newExpirations;
      this.expirations_by_group_filtered = this.expirations_by_group;
    });
  }

  onSearchChange(search: string): void {
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }

    this.debounceTimeout = setTimeout(() => {
      if (search === 'ship') {
        this.searchShips();
      } else if (search === 'expiration') {
        this.searchExpiration();
      }
    }, 300);
  }

  removeAccents(str: string) {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  searchShips(): void {
    this.filtered_ships = this.ship_list.filter((item) => {
      return this.removeAccents(item.name).toLowerCase().includes(this.removeAccents(this.search_ship_value).toLowerCase());
    });
  }

  searchExpiration(): void {
    this.expirations_by_group_filtered = this.expirations_by_group.filter((item: any) => {
      return this.removeAccents(item.name).toLowerCase().includes(this.removeAccents(this.search_expiration_value).toLocaleLowerCase());
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/expirations/expiration-list/expiration-list.component.ts